import { defineComponent as r, h as n } from "vue";
const t = r({
  name: "DropdownRenderOption",
  props: {
    tmNode: {
      type: Object,
      required: !0
    }
  },
  render() {
    const { rawNode: { render: e, props: o } } = this.tmNode;
    return n("div", o, [e == null ? void 0 : e()]);
  }
});
export {
  t as default
};
